<template>
  <div>

    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="用户名">
        <el-input size="small" v-model="formInline.userName" placeholder="输入用户名"></el-input>
      </el-form-item>
      <el-form-item label="房间ID">
        <el-input size="small" v-model="formInline.roomId" placeholder="输入房间ID"></el-input>
      </el-form-item>
      <el-form-item label="是否白名单">
        <el-select size="small" v-model="formInline.white" placeholder="请选择">
          <el-option v-for="item in typeWhite" :label="item.key" :value="item.value" :key="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否开启">
        <el-select size="small" v-model="formInline.open" placeholder="请选择">
          <el-option v-for="item in typeWhite" :label="item.key" :value="item.value" :key="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间">
        <el-date-picker
        size="small"
        v-model="timeVal"
        value-format="yyyy-MM-dd"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
      </el-form-item>
      
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">

      <el-table-column align="center"  prop="userName" label="用户名" min-width="200">
      </el-table-column>
      <el-table-column align="center"  prop="open" label="是否开起" min-width="50">
        <template slot-scope="scope">
            <div v-if="scope.row.open"><el-tag>是</el-tag></div>
            <div v-else ><el-tag type="danger">否</el-tag></div>
          </template>
      </el-table-column>
      <el-table-column align="center"  prop="open" label="是否白名单" min-width="80">
        <template slot-scope="scope">
            <div v-if="!scope.row.white"><el-tag>是</el-tag>&nbsp;&nbsp;&nbsp;<el-button size="mini" type="success" @click="onWhite(scope.row.rId,true)">添加白名单</el-button></div>
            <div v-else ><el-tag type="danger">否</el-tag>&nbsp;&nbsp;&nbsp;<el-button size="mini" type="danger" @click="onWhite(scope.row.rId,false)">移除白名单</el-button></div>
          </template>
      </el-table-column>
      <el-table-column align="center" prop="roomId" label="房间ID" min-width="100">
      </el-table-column>
      <el-table-column align="center" prop="setupTime" label="创建时间" min-width="200">
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
import { RoomList , SwitchWhite } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
     
      formInline: {
        "from": 1,
        "limit": 10,
        "startTime": "",
        "endTime": "",
        "roomId": "",
        "userName": "",
        "open": 0,
        "white":0
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      typeWhite: [
        { key: '默认', value: 0 },
        { key: '是', value: 1 },
        { key: '否', value: 2 },
      ],
      timeVal:"",
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取转入列表
    getdata(parameter) {
      this.loading = true
      RoomList(parameter)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.listData = res.data.list
            // 分页赋值
            // this.pageparm.currentPage = this.formInline.from
            // this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('列表加载失败，请稍后再试！')
        })
    },

    onWhite(id,falg){
      this.$confirm(falg?'是否移除白名单':'是否添加白名单', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          SwitchWhite({rId:id}).then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.$message({
              type: 'success',
              message: '成功!'
            });
            this.getdata(this.formInline)
          }
        })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });          
        });
      
    },

    // 分页插件事件
    callFather(parm) {
      this.pageparm.pageSize = parm.pageSize
      this.formInline.from = (parm.currentPage-1)*(this.pageparm.pageSize) + 1
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },

    // 搜索事件
    search() {
      this.pageparm.currentPage = 1
      this.formInline.from = 1
      console.log(this.timeVal)
      if(this.timeVal instanceof Array){
        this.formInline.startTime = this.timeVal[0]+' 00:00:00'
        this.formInline.endTime = this.timeVal[1]+' 23:59:59'
      }else{
        this.formInline.startTime = ''
        this.formInline.endTime = ''
      }
      this.getdata(this.formInline)
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}

.box-card{
  width: 600px;
  margin-top: 20px;
  font-size: 14px;
}
.box-card div{
  display: flex;
}
.box-card div p{margin-right: 10px;}
.box-card p{margin: 0;margin-bottom: 10px;}
.box-card h3{margin: 0;margin-bottom: 15px;}
</style>

 
 


// WEBPACK FOOTER //
// src/views/wallet/UserRoom.vue